import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader';
let vm;
// let scene, scale, camera, renderer, controls
export default {
  name: 'three',
  data() {
    return {
      datas: [{
        img: 'http://192.168.20.27:8080/test/5-001hjcw_A.jpg',
        obj: 'http://192.168.20.27:8080/test/5-001hjcw.obj',
        angleX: 0,
        angleY: 0,
        angleZ: 0,
        axisX: 0,
        axisY: 0,
        axisZ: 0
      }],
      models: ['http://192.168.20.27:8080/test/5-001hjcw.obj']
    };
  },
  methods: {
    init3D() {
      var PLight = 0.23;
      this.scene = new THREE.Scene();
      // 点光源
      var pointLight = new THREE.PointLight(0xffffff, PLight);
      pointLight.position.set(-300, 0, -100);
      this.scene.add(pointLight);
      var pointLight1 = new THREE.PointLight(0xffffff, PLight);
      pointLight1.position.set(100, 0, 300);
      this.scene.add(pointLight1);
      var pointLight2 = new THREE.PointLight(0xffffff, PLight);
      pointLight2.position.set(300, 0, -300);
      this.scene.add(pointLight2);
      var pointLight4 = new THREE.PointLight(0xffffff, PLight);
      pointLight4.position.set(0, -300, 0);
      this.scene.add(pointLight4);
      // 环境光
      var ambient = new THREE.AmbientLight(0x444444);
      this.scene.add(ambient);
      this.camera = new THREE.PerspectiveCamera(35, window.innerWidth / window.innerHeight, 1, 10000);
      // this.camera.position.set(0, 0, 250)
      this.camera.lookAt(new THREE.Vector3(0, 0, 0));
      this.scene.add(this.camera);

      // 渲染器
      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      });
      // this.renderer.setClearAlpha(0.0)
      this.renderer.outputEncoding = THREE.LinearEncoding;
      this.renderer.setPixelRatio(window.devicePixelRatio); // 设置渲染区域尺寸
      let w = document.documentElement.clientWidth;
      let h = document.documentElement.clientHeight;
      this.renderer.setSize(w, h);
      this.$refs.content.appendChild(this.renderer.domElement);
      // this.controls = new TrackballControls(this.camera, this.renderer.domElement);
      // this.controls.minDistance = 200;
      //    this.controls.maxDistance = 2000;
      this.onProgress = function (xhr) {};
      this.loadNextObj();
    },
    loadNextObj() {
      let that = this;
      let manager = new THREE.LoadingManager();
      console.log(manager);
      var objLoader = new OBJLoader();
      let mtlLoader = new MTLLoader();
      var textureLoader = new THREE.TextureLoader();
      var texture = textureLoader.load(this.datas[0].img);
      texture.minFilter = THREE.NearestFilter;
      //  loader.setPath('http://192.168.20.27:8080/test/')

      // let loader=new OBJLoader();
      objLoader.load('/test/5-001hjcw.obj', obj => {
        obj.scale.set(1, 1, 1);
        that.scene.add(obj);
        that.render();
      });
      // mtlLoader.load('/test/5-001hjcw.obj', function (materials) {
      //   // materials.preload();
      //   objLoader.setMaterials(materials)
      //   objLoader.load(
      //     '/test/5-001hjcw.obj',
      //     function (obj) {
      //       obj.position.set(5, 5, 5)
      //       obj.scale.set(1,1,1)
      //       that.scene.add(obj)
      //     },
      //     //   called while loading is progressing
      //     function (xhr) {
      //       console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
      //     },
      //     //   called when loading has errors
      //     function (error) {
      //       console.log('An error happened')
      //     }
      //   )
      // })
    },
    animate() {
      // requestAnimationFrame(this.animate);
      // if (this.controls) {
      //   this.controls.update();
      //   this.render();
      // } else {
      //   cancelAnimationFrame(this.animate)
      // }
      this.render();
    },
    render() {
      this.renderer.render(this.scene, this.camera);
    }
  },
  created() {
    vm = this;
  },
  mounted() {
    this.$nextTick(() => {
      this.init3D();
      this.animate();
    });
  },
  computed: {}
};